import { render, staticRenderFns } from "./LiveTransplant.vue?vue&type=template&id=e9766ce4"
import script from "./LiveTransplant.vue?vue&type=script&lang=js"
export * from "./LiveTransplant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports